import React from 'react';

interface IStarOutlineProps {
    size?: number;
}

export const StarOutline: React.FC<IStarOutlineProps> = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.5002 1.8335L14.3327 7.57183L20.6668 8.49766L16.0835 12.9618L17.1652 19.2685L11.5002 16.2893L5.83516 19.2685L6.91683 12.9618L2.3335 8.49766L8.66766 7.57183L11.5002 1.8335Z"
                stroke="#64469E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};
